import React, { useMemo, useState } from 'react'
import MilestonePayoutPNG from "assets/images/milestone-payouts.png"
import MilestoneMediaPNG from "assets/images/milestone-media.png"
import InstagramReelIconPNG from "assets/icons/instagram-reel.png"
import { useParams } from 'react-router-dom'
import { getMediaTypeFromURL } from 'utils/helpers'
import { CollaborationItem, Milestone, MilestoneData } from 'types/collaboration'
import ExpandableWYSIWYGPreview from 'Components/Common/ExpandableWYSIWYGPreview'
import HTMLContent from 'Components/Common/HTMLContent'
import { useSelector } from 'react-redux'
import { RootState } from 'store'
interface SpecificationsProps {
    activeMilestone: Milestone,
    campaign: Pick<CollaborationItem['campaign'], "name" | "uuid">,
    acknowledgementRequired?: boolean,
    onAcknowledgement: (ack: boolean) => void,
    showDisabledTooltip?: boolean,
    setSelectedMedia: (post: any) => void
}

const Specifications: React.FC<SpecificationsProps> = ({ activeMilestone, campaign, showDisabledTooltip, acknowledgementRequired = false, onAcknowledgement, setSelectedMedia }) => {

    const [acknowledged, setAcknowledged] = useState(false);
    const {campaignId, milestoneId, influencerId} = useParams();
    const [acknowledging, setAcknowledging] = useState(false);

    const collaboration = useSelector((state: RootState) => state.legacyCollaborations.items[campaignId!]?.[influencerId!]?.collaboration);


    const samplePosts = useMemo(() => {
        const campaignFiles = Array.isArray(activeMilestone?.campaign_files) ? activeMilestone.campaign_files : [];

        return campaignFiles.filter((campaignFile) => campaignFile.type === 'sample_post');
    }, [activeMilestone.campaign_files])

    const creatives = useMemo(() => {
        const campaignFiles = Array.isArray(activeMilestone?.campaign_files) ? activeMilestone.campaign_files : [];

        return campaignFiles.filter((campaignFile) => campaignFile.type === 'creative');
    }, [activeMilestone.campaign_files])

    const acknowledge = async () => {
        if(!campaignId || !milestoneId || !acknowledged) return;

        try {
            setAcknowledging(true);
            // await acknowledgeMilestone(campaignId, milestoneId);
            onAcknowledgement(true);
        } catch (error) {
            console.log(error);
        } finally {
            setAcknowledging(false);
        }
    }


    return (
        <div className='position-relative'>
            <div className="specification-card">
                <h6 className="specification-card-title pop">{campaign.name}</h6>
                <div className='specification-card-content'>
                    <HTMLContent content={activeMilestone?.brief ?? ''} />
                </div>
            </div>
            <div className="specification-card">
                <div className="specification-card-header">
                    <h6 className="specification-card-title pop">Media Requirements</h6>
                    <img src={MilestoneMediaPNG} className='milestone-spec-illustrator' alt='milestone-payout' />
                </div>
                <div className='specification-card-content'>
                    <div className="milestone-media-requirements">
                        {
                            collaboration?.platform === 'ig' &&
                            <>
                                <div className="milestone-media-requirement">
                                    <span>{activeMilestone.content_media_types.REELS}</span>
                                    <span>Reel</span>
                                </div>
                                <div className="milestone-media-requirement">
                                    <span>{activeMilestone.content_media_types.STORY}</span>
                                    <span>Story</span>
                                </div>
                                <div className="milestone-media-requirement">
                                    <span>{activeMilestone.content_media_types.FEED}</span>
                                    <span>Post</span>
                                </div>
                            </>
                        }
                        {
                            collaboration?.platform === 'yt' &&
                            <div className="milestone-media-requirement">
                                <span>{activeMilestone.content_media_types.VIDEO}</span>
                                <span>Video</span>
                            </div>
                        }
                    </div>
                </div>
            </div>
            <div className="specification-card">
                <div className="specification-card-header">
                    <h6 className="specification-card-title pop">Milestone Payouts</h6>
                    <img src={MilestonePayoutPNG} className='milestone-spec-illustrator' alt='milestone-payout' />
                </div>
                <div className='specification-card-content'>
                    <div className="milestone-media-requirements">
                        <div className="milestone-media-requirement">
                            <span>₹{activeMilestone.gig_amount}</span>
                            <span>Milestone Payout</span>
                        </div>
                        {
                            activeMilestone.barter_amount ?
                            <div className="milestone-media-requirement">
                                <span><span className='upto me-1'>upto</span>₹{activeMilestone.barter_amount}</span>
                                <span>{activeMilestone?.barter_reimbursement ? 'Reimbursement' : 'Barter'} Amount</span>
                            </div> : null
                        }
                    </div>
                </div>
            </div>
            {
                Array.isArray(activeMilestone?.specifications?.talking_points) && activeMilestone.specifications.talking_points.length > 0 &&
                activeMilestone?.specifications?.talking_points.map((talkingPoint, i) => {
                    return (
                        <div className="specification-card" key={i}>
                            <h6 className="specification-card-title pop">{talkingPoint.title}</h6>
                            <div className='specification-card-content'>
                                <ul className='specification-content-list'>
                                    {
                                        Array.isArray(talkingPoint.pointers) && talkingPoint.pointers.length > 0 &&
                                        talkingPoint.pointers.map((pointer, j) => {
                                            return (
                                                <li key={j}>
                                                    {pointer}
                                                </li>
                                            )
                                        })
                                    }
                                </ul>
                            </div>
                        </div>
                    )
                })

            }
            {
                Array.isArray(activeMilestone?.specifications?.do) && activeMilestone.specifications.do.length > 0 &&
                <div className="specification-card">
                    <h6 className="specification-card-title pop">Do(s)</h6>
                    <div className='specification-card-content'>
                        <ul className='specification-content-list'>
                            {
                                activeMilestone.specifications.do.map((content, i) => {
                                    return (
                                        <li key={i}>{content}</li>
                                    )
                                })
                            }
                        </ul>
                    </div>
                </div>
            }
            {
                Array.isArray(activeMilestone?.specifications?.dont) && activeMilestone.specifications.dont.length > 0 &&
                <div className="specification-card">
                    <h6 className="specification-card-title pop">Don't(s)</h6>
                    <div className='specification-card-content'>
                        <ul className='specification-content-list'>
                            {
                                activeMilestone.specifications.dont.map((content, i) => {
                                    return (
                                        <li key={i}>{content}</li>
                                    )
                                })
                            }
                        </ul>
                    </div>
                </div>
            }
            {
                Array.isArray(activeMilestone?.specifications?.must_have) && activeMilestone.specifications.must_have.length > 0 &&
                <div className="specification-card">
                    <h6 className="specification-card-title pop">Must Have(s)</h6>
                    <div className='specification-card-content'>
                        <ul className='specification-content-list'>
                            {
                                activeMilestone.specifications.must_have.map((content, i) => {
                                    return (
                                        <li key={i}>{content}</li>
                                    )
                                })
                            }
                        </ul>
                    </div>
                </div>
            }
            {
                Array.isArray(activeMilestone?.specifications?.sample_scripts) && activeMilestone.specifications.sample_scripts.length > 0 &&
                <div className="specification-card">
                    <h6 className="specification-card-title pop">Sample Scripts</h6>
                    <div className='specification-card-content'>
                            {
                                activeMilestone.specifications.sample_scripts.map((content, i) => {
                                    return (
                                        <div className="script-preview">
                                            <ExpandableWYSIWYGPreview content={content} key={i} />
                                        </div>

                                    )
                                })
                            }
                    </div>
                </div>
            }
            {
                Array.isArray(activeMilestone?.specifications?.sample_captions) && activeMilestone.specifications.sample_captions.length > 0 &&
                <div className="specification-card">
                    <h6 className="specification-card-title pop">Sample Captions</h6>
                    <div className='specification-card-content'>
                        <ul className='specification-content-list'>
                            {
                                activeMilestone.specifications.sample_captions.map((content, i) => {
                                    return (
                                        <li key={i}>{content}</li>
                                    )
                                })
                            }
                        </ul>
                    </div>
                </div>
            }
            {
                Array.isArray(activeMilestone?.specifications?.hashtags) && activeMilestone.specifications.hashtags.length > 0 &&
                <div className="specification-card">
                    <h6 className="specification-card-title pop">Hashtag(s)</h6>
                    <div className='specification-card-content'>
                        <ul className='specification-content-list'>
                            {
                                activeMilestone.specifications.hashtags.map((content, i) => {
                                    return (
                                        <li key={i}>{content}</li>
                                    )
                                })
                            }
                        </ul>
                    </div>
                </div>
            }
            {
                Array.isArray(activeMilestone?.specifications?.mentions) && activeMilestone.specifications.mentions.length > 0 &&
                <div className="specification-card">
                    <h6 className="specification-card-title pop">Mention(s)</h6>
                    <div className='specification-card-content'>
                        <ul className='specification-content-list'>
                            {
                                activeMilestone.specifications.mentions.map((content, i) => {
                                    return (
                                        <li key={i}>{content}</li>
                                    )
                                })
                            }
                        </ul>
                    </div>
                </div>
            }
            {
                Array.isArray(activeMilestone?.specifications?.collaborators) && activeMilestone.specifications.collaborators.length > 0 &&
                <div className="specification-card">
                    <h6 className="specification-card-title pop">Collaborator(s)</h6>
                    <div className='specification-card-content'>
                        <ul className='specification-content-list'>
                            {
                                activeMilestone.specifications.collaborators.map((content, i) => {
                                    return (
                                        <li key={i}>{content}</li>
                                    )
                                })
                            }
                        </ul>
                    </div>
                </div>
            }
            {
                creatives.length > 0 &&
                <div className="specification-card">
                    <h6 className="specification-card-title pop">Creatives</h6>
                    <div className='specification-card-content'>
                        <div className="row mb-0 g-0">
                            {
                                creatives.map((creative, i) => {
                                    return (
                                        <div className="col-3 p-3" key={i}>
                                            <a href={creative.url} target='_blank' className="d-block creative bg-media bgc-white" style={{
                                                backgroundImage: `url(${creative.url})`
                                            }}></a>
                                        </div>
                                    )
                                })
                            }
                        </div>
                    </div>
                </div>
            }
            {
                samplePosts.length > 0 &&
                <div className="specification-card">
                    <h6 className="specification-card-title pop">Sample Media Posts</h6>
                    <div className='specification-card-content'>
                        <div className="row mb-0 g-0">
                            {
                                samplePosts.map((samplePost, i) => {
                                    return (
                                        <div className="col-6 col-md-3 p-1" key={i}>
                                            {
                                                getMediaTypeFromURL(samplePost.url) === 'image' &&
                                                <div onClick={() => setSelectedMedia(samplePost)} className="sample-post bg-media bgc-content" style={{
                                                    backgroundImage: `url(${samplePost.url})`
                                                }}></div>
                                            }
                                            {
                                                getMediaTypeFromURL(samplePost.url) === 'video' &&
                                                <div onClick={() => setSelectedMedia(samplePost)} className="curson-pointer w-100 position-relative bgc-content sample-post overflow-hidden">
                                                    <video className='w-100 h-100' src={samplePost.url} />
                                                    <img className='ig-reel-icon' src={InstagramReelIconPNG} alt='IG Reel' />
                                                </div>
                                            }
                                        </div>
                                    )
                                })
                            }
                        </div>
                    </div>
                </div>
            }

            {
                acknowledgementRequired &&
                <React.Fragment>
                    <div className='d-flex align-items-center mt-4'>
                        <div className="gig-selection-checkbox-wrapper me-1">
                            <input type='checkbox' id='acknowledgement' className='form-check-input gig-selection-check-input' checked={acknowledged} onChange={() => setAcknowledged(!acknowledged)} />
                        </div>
                        <label className='acknowledgement-check-label' htmlFor='acknowledgement'>I have read all the information</label>
                    </div>

                    <button onClick={() => acknowledge()} className="theme-btn theme-btn-primary w-100 my-3" disabled={!acknowledged || acknowledging}>{acknowledging ? 'Please wait...' : 'Acknowledge'}</button>
                </React.Fragment>
            }
            {
                showDisabledTooltip &&
                <div className="disabled-tip-wrapper">
                    <div className="disabled-tip">
                        Kindly read the entire specifications section before continuing.
                    </div>
                </div>
            }

        </div>
    )
}

export default Specifications